
export const PATIENT = 'PATIENT'
export const CAREGIVER = 'CAREGIVER'
export const REF_PHYSICIAN = 'REF_PHYSICIAN'
export const LOCAL_PHYSICIAN = 'LOCAL_PHYSICIAN'
export const OTHER = 'OTHER'
// Need to add a "Relation to patient" field here, with the following options: 
// Legal Guardian, Executor, Parent of Minor, or "Other" with the option to fill in relation
export const LEGALGUARDIAN = 'LEGAL_GUARDIAN'
export const EXECUTOR = 'EXECUTOR'
export const PARENT = 'PARENT_OF_MINOR'

export const CONTACT_RELATION_LEGAL_LABELS = {[PATIENT]:"Client",[LEGALGUARDIAN]:"Legal Guardian",[EXECUTOR]:"Executor",[PARENT]:"Parent of Minor",[OTHER]:"Other"}
export const CONTACT_RELATION_LEGAL_OPTIONS = Object.keys(CONTACT_RELATION_LEGAL_LABELS)

export const CONTACT_RELATION_MEDICAL_LABELS = {[PATIENT]:"Patient",[CAREGIVER]:"Caregiver",[REF_PHYSICIAN]:"Referring physician", [LOCAL_PHYSICIAN]:"Local physician",[PARENT]:"Parent",[LEGALGUARDIAN]:"Legal Guardian",[OTHER]:"Other"}
export const CONTACT_RELATION_MEDICAL_OPTIONS = Object.keys(CONTACT_RELATION_MEDICAL_LABELS)

export const INTL_CONTACT_RELATION_MEDICAL_LABELS = (intl) => ({
    PATIENT: intl.formatMessage({defaultMessage:"Patient",description:"Contact relation label: Patient"}),
    CAREGIVER: intl.formatMessage({defaultMessage:"Caregiver",description:"Contact relation label: Caregiver"}),
    REF_PHYSICIAN: intl.formatMessage({defaultMessage:"Referring physician",description:"Contact relation label: Referring physician"}),
    LOCAL_PHYSICIAN: intl.formatMessage({defaultMessage:"Local physician",description:"Contact relation label: Local physician"}),
    PARENT_OF_MINOR: intl.formatMessage({defaultMessage:"Parent",description:"Contact relation label: Parent"}),
    LEGAL_GUARDIAN: intl.formatMessage({defaultMessage:"Legal Guardian",description:"Contact relation label: Legal Guardian"}),
    OTHER: intl.formatMessage({defaultMessage:"Other",description:"Contact relation label: Other"})
})